import React from 'react'

function ListeInstitutions({ institutions }) {
  return (
    <div className="liste-institutions">
      <h3>Institutions partenaires accessibles</h3>
      <ul>
        {institutions.map((institution, index) => (
          <li key={index}>
            <strong>{institution.nom}</strong> - {institution.type} ({institution.adresse})
          </li>
        ))}
      </ul>
    </div>
  )
}

export default ListeInstitutions